// The five lift-spec inputs, shared so neither surface offers four of them. See lolerLiftSpec.ts.
import { LIFT_SPEC_FIELDS, type LiftSpecDetails } from "./lolerLiftSpec";

const FIELD_LABEL: Record<(typeof LIFT_SPEC_FIELDS)[number], string> = {
  liftType: "Lift type",
  liftSerialNumber: "Serial / plant number",
  liftFloors: "Floors served",
  liftInstallYear: "Install year",
  liftAgeYears: "Age (years)",
};
const FIELD_TYPE: Partial<Record<(typeof LIFT_SPEC_FIELDS)[number], string>> = {
  liftFloors: "number",
  liftInstallYear: "number",
  liftAgeYears: "number",
};

/**
 * The lift's own technical specification -- serial number, lift type, floors served, and either an
 * install year or a stated age -- as read off a LOLER report. Not every report states all of them;
 * every field is optional both here and on the server.
 *
 * The classes come from the caller, matching PreContractFields' own reasoning: the sweep card is
 * compact, the manual New report modal is not.
 */
export function LiftSpecFields({
  value,
  onChange,
  disabled,
  idPrefix,
  labelCls,
  inputCls,
  className,
}: {
  value: LiftSpecDetails;
  onChange: (patch: Partial<LiftSpecDetails>) => void;
  disabled?: boolean;
  idPrefix: string;
  labelCls: string;
  inputCls: string;
  className?: string;
}) {
  return (
    <div className={className ?? "grid grid-cols-1 gap-3 sm:grid-cols-2"}>
      {LIFT_SPEC_FIELDS.map((k) => (
        <div key={k}>
          <label className={labelCls} htmlFor={`${idPrefix}-${k}`}>
            {FIELD_LABEL[k]}
          </label>
          <input
            id={`${idPrefix}-${k}`}
            type={FIELD_TYPE[k] ?? "text"}
            className={inputCls}
            value={value[k]}
            disabled={disabled}
            onChange={(e) => onChange({ [k]: e.target.value } as Partial<LiftSpecDetails>)}
          />
        </div>
      ))}
    </div>
  );
}
